<template>
  <div>
    <!-- 제목 -->
    <v-sheet outlined class="d-flex align-center ma-2 px-4" height="60">
      <font class="font-weight-bold text-h6 grey--text text--darken-2">옵션 상품 관리</font>
    </v-sheet>

    <!-- 본문 -->
    <v-sheet outlined class="pa-2 ma-2">
      <!-- 검색 -->
      <v-sheet outlined class="pa-2 mb-2 d-flex">
        <v-sheet class="d-flex align-center" width="800">
          <!-- 유형 -->
          <v-sheet width="160" class="mr-3">
            <v-select outlined dense hide-details :items="select_list.search_type" v-model="search_type"></v-select>
          </v-sheet>

          <!-- 키워드 -->
          <v-text-field placeholder="검색어를 입력해주세요" outlined dense hide-details v-model="keyword" @keyup.enter="search()"></v-text-field>

          <!-- 제출 버튼 -->
          <v-btn height="40" class="px-6 ml-3" color="primary" dark depressed @click="search()">
            <v-icon small left>mdi-magnify</v-icon>
            검색하기
          </v-btn>
        </v-sheet>
      </v-sheet>

      <!-- 목록 -->
      <v-radio-group v-model="selected" hide-details>
        <v-data-table
          hide-default-header
          :items="list"
          :footer-props="{
            'items-per-page-options': [10, 20, 100, -1],
            itemsPerPageText: '페이지당 아이템수',
          }"
          no-data-text=""
        >
          <template v-slot:header>
            <tr>
              <th style="width: 52px"></th>
              <th style="width: 120px">코드</th>
              <th style="width: 150px">상품명</th>
              <th style="width: 180px">설명</th>
              <th style="width: 100px">가격</th>
              <th style="width: 90px">타입</th>
              <th style="width: 90px">최대갯수</th>
              <th style="width: 120px">설명 페이지</th>
              <th style="width: 110px">생성일</th>
              <th style="width: 110px">수정일</th>
            </tr>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <v-radio class="ml-1" hide-details dense :value="item" @change="selectedItem = item"></v-radio>
              </td>
              <td class="text-truncate">
                {{ item.code }}
              </td>
              <td class="text-truncate">
                {{ getTitleText(item.title) }}
              </td>
              <td class="text-truncate">
                {{ getSubTitleText(item.subTitle) }}
              </td>
              <td class="text-truncate">
                {{ item.price ? $toComma(item.price) + "원" : "-" }}
              </td>
              <td class="text-truncate">
                {{ item.type || "single" }}
              </td>
              <td class="text-truncate">
                {{ item.type === "multiple" && item.maxCount ? item.maxCount : "-" }}
              </td>
              <td class="text-truncate">
                {{ item.descriptionCode || "-" }}
              </td>
              <td class="text-truncate text-caption">
                {{ item.createdAt ? dayjs(new Date(item.createdAt)).format("YYYY-MM-DD HH:mm") : "-" }}
              </td>
              <td class="text-truncate text-caption">
                {{ item.updatedAt ? dayjs(new Date(item.updatedAt)).format("YYYY-MM-DD HH:mm") : "-" }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-radio-group>

      <!-- 버튼 -->
      <v-card class="mt-2 pa-2 d-flex justify-end" outlined>
        <v-btn class="px-6 ml-3" color="green" large dark depressed @click="updateOpen()">
          <v-icon small left>mdi-database-edit-outline</v-icon>
          수정하기
        </v-btn>

        <v-btn class="px-6 ml-3" color="blue" large dark depressed @click="createNew()">
          <v-icon small left>mdi-database-plus-outline</v-icon>
          추가하기
        </v-btn>

        <v-btn class="px-6 ml-3" color="red" large dark depressed @click="deleteItem()">
          <v-icon small left>mdi-database-remove-outline</v-icon>
          삭제하기
        </v-btn>
      </v-card>
    </v-sheet>

    <!-- 옵션 상품 수정하기 -->
    <v-dialog v-model="dialog.update" width="800" content-class="rounded-xl" persistent>
      <UpdateOptionProduct :updateItem_import="selectedItem" @close="close_handler" :key="componentKey" />
    </v-dialog>

    <!-- 옵션 상품 추가하기 -->
    <v-dialog v-model="dialog.create" width="800" content-class="rounded-xl" persistent>
      <InsertOptionProduct @close="close_handler" :key="componentCreateKey" />
    </v-dialog>
  </div>
</template>

<script>
import optionProductService from "../../api/optionProductService"
import InsertOptionProduct from "./optionProducts/InsertOptionProduct"
import UpdateOptionProduct from "./optionProducts/UpdateOptionProduct"

export default {
  name: "OptionProducts",

  components: {
    InsertOptionProduct,
    UpdateOptionProduct,
  },

  data: () => ({
    select_list: {
      search_type: ["코드", "상품명"],
    },

    search_type: "상품명",
    keyword: "",

    list: [],

    selected: false,
    selectedItem: {},

    componentKey: 0,
    componentCreateKey: 0,

    dialog: {
      create: false,
      update: false,
    },
  }),

  async mounted() {
    // 목록
    this.search()
  },

  watch: {
    selectedItem() {
      console.log(this.selectedItem)
      this.componentKey++
    },
  },

  methods: {
    // 목록
    async search() {
      try {
        const response = await optionProductService.getOptionProducts({
          type: this.search_type,
          keyword: this.keyword,
        })
        console.log(response)
        this.list = response || []
      } catch (error) {
        console.error("옵션 상품 목록 조회 실패:", error)
        this.$toast.error("옵션 상품 목록을 불러오는데 실패했습니다.")
        this.list = []
      }
    },

    // 닫기 핸들러
    close_handler() {
      this.dialog.create = false
      this.dialog.update = false
      this.selected = false
      this.selectedItem = {}
      this.search()
    },

    // 수정하기
    updateOpen() {
      if (!this.selectedItem || !this.selectedItem.id) {
        alert("선택한 항목이 없습니다")
      } else {
        this.componentKey++
        this.dialog.update = true
      }
    },

    // 추가하기
    createNew() {
      this.dialog.create = true
      this.componentCreateKey++
    },

    // 삭제하기
    async deleteItem() {
      if (!this.selectedItem || !this.selectedItem.id) {
        alert("선택한 항목이 없습니다")
      } else {
        if (confirm("정말 해당 아이템을 삭제하겠습니까?")) {
          try {
            await optionProductService.deleteOptionProduct(this.selectedItem.id)
            alert("정상적으로 삭제되었습니다.")
            this.search()
            this.selected = false
            this.selectedItem = {}
          } catch (error) {
            console.error("옵션 상품 삭제 오류:", error)
            alert(error.message || "삭제 중 오류가 발생했습니다")
          }
        }
      }
    },

    // Helper methods for displaying JSON fields
    getTitleText(title) {
      if (!title) return "-"
      try {
        const parsed = typeof title === "string" ? JSON.parse(title) : title
        return parsed.kr || parsed.en || parsed.jp || "-"
      } catch (e) {
        return title
      }
    },

    getSubTitleText(subTitle) {
      if (!subTitle) return "-"
      try {
        const parsed = typeof subTitle === "string" ? JSON.parse(subTitle) : subTitle
        return parsed.kr || parsed.en || parsed.jp || "-"
      } catch (e) {
        return subTitle
      }
    },
  },
}
</script>
